import React, { useState } from 'react'
import { Grid, useMediaQuery } from '@material-ui/core'
import "./digital-vault-categories-administration-new-category.css"
import { RadioButton } from '@progress/kendo-react-inputs'
import categories_icons from './categories_icons'
import { DropDownBtnHLPure, InputHLPure, TextAreaHLPure, ButtonHLPure, ButtonAddHLPure, DialogTemplatePure } from '../../pures'
import { useTranslation } from 'react-i18next'

const DigitalVaultCategoriesAdministrationAddCategory = (props) => {
    const {
        defaultCategories,
        setShowDetails,
        selectedValueFilter,
        categories,
        createCategory,
        assignCategory,
    } = props
    const { t } = useTranslation()

    const dropdownOptions = [
        { name: t("digitalVaultCategoriesAdministration.add.options.notAssigned"), levelUser: "" },
        { name: t("digitalVaultCategoriesAdministration.add.options.administrator"), levelUser: Number(process.env.REACT_APP_COMPANY_ROLE_ID_ADMIN) },
        { name: "N1", levelUser: Number(process.env.REACT_APP_COMPANY_ROLE_ID_N1) },
        { name: "N2", levelUser: Number(process.env.REACT_APP_COMPANY_ROLE_ID_N2) },
        { name: "N3", levelUser: Number(process.env.REACT_APP_COMPANY_ROLE_ID_N3) }
    ]

    const dropdownOptionType =
        [
            {
                name: t("digitalVaultCategoriesAdministration.add.options.selectAType"),
                value: ""
            },
            {
                name: t("digitalVaultCategoriesAdministration.main.grid.default"),
                value: t("digitalVaultCategoriesAdministration.main.grid.default")
            },
            {
                name: t("digitalVaultCategoriesAdministration.main.grid.custom"),
                value: t("digitalVaultCategoriesAdministration.main.grid.custom")
            }
        ]

    const selectedUserId = categories.find(item => item.company.id === selectedValueFilter).company.id
    const selectedFilterText = categories.find(item => item.company.id === selectedValueFilter).company.companyName
    let categoriesDefault = categories.find(item => item.company.id === selectedValueFilter).categories.filter(item => item.defined === t("digitalVaultCategoriesAdministration.main.grid.default"))
    let defaultToShow = [...defaultCategories]
    const [saveImg, setSaveImg] = useState(null)

    for (let i = 0; i < categoriesDefault.length; i++) {
        let indexCategory = defaultToShow.findIndex(item => item.key === categoriesDefault[i].key)
        defaultToShow.splice(indexCategory, 1)
    }

    if (defaultToShow.length === 0) {
        const indexToDelete = dropdownOptionType.findIndex(item => item.value === t("digitalVaultCategoriesAdministration.main.grid.default"))
        dropdownOptionType.splice(indexToDelete, 1)
    }

    const [categoryData, setCategoryData] = useState({ name: "", id: defaultToShow[0]?.id ?? 0, categoryType: "", minimunVisualization: null, notes: "", icon: null })
    const [showError, setShowError] = useState(false)
    const [showCategoryError, setShowCategoryError] = useState(false)
    const [showAddIcon, setShowAddIcon] = useState(false)

    const createCategoryCompany = () => {
        if (!categoryData.categoryType) return setShowCategoryError(true), setTimeout(() => {
            setShowCategoryError(false)
        }, 2000);
        if (categoryData.categoryType === t("digitalVaultCategoriesAdministration.main.grid.custom") && !categoryData.name) return setShowError(true), setTimeout(() => {
            setShowError(false)
        }, 2000);

        categoryData.categoryType === t("digitalVaultCategoriesAdministration.main.grid.custom")
            ? createCategory(categoryData.name, categoryData.minimunVisualization, selectedUserId, categoryData.notes, categoryData.icon)
            : assignCategory(categoryData.id, categoryData.minimunVisualization, selectedUserId, categoryData.notes)
    }

    const isMobile = useMediaQuery("(max-width:560px)")

    return (
        <>
            <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="digitalVaultCategoriesAdministrationNewCategory-wrapper"
            >
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className='digitalVaultCategoriesAdministrationNewCategory-paddingElements'
                >
                    <span>
                        {t("digitalVaultCategoriesAdministration.add.categoryApplies")} <b>{selectedFilterText}</b>
                    </span>
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="digitalVaultCategoriesAdministrationNewCategory-paddingElements"
                >
                    <DropDownBtnHLPure
                        labelDropDown={t("digitalVaultCategoriesAdministration.add.categoryType")}
                        optionsDropDown={dropdownOptionType}
                        onDropDownChange={(e) => setCategoryData({ ...categoryData, categoryType: e.target.value })}
                        optionsValue={t("digitalVaultCategoriesAdministration.add.options.selectAType")}
                        valueItem={"value"}
                        nameOption={"name"}
                    />
                    {showCategoryError && <div>Ingrese un tipo de categoría</div>}
                </Grid>
                {categoryData.categoryType === t("digitalVaultCategoriesAdministration.main.grid.default") &&
                    <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="digitalVaultCategoriesAdministrationNewCategory-paddingElements"
                    >
                        <DropDownBtnHLPure
                            labelDropDown={t("digitalVaultCategoriesAdministration.add.category")}
                            optionsDropDown={defaultToShow}
                            onDropDownChange={(e) => setCategoryData({ ...categoryData, id: e.target.value })}
                            optionsValue={t("digitalVaultCategoriesAdministration.add.categoryType")}
                            valueItem={"id"}
                            nameOption={"name"}
                            informationIcon
                            tooltipShow
                            positionTooltip={isMobile ? "top" : "right"}
                            titleTooltip={t("digitalVaultCategoriesAdministration.add.category")}
                            descriptionTooltip={t("digitalVaultCategoriesAdministration.add.selectCatDefault")}
                        />
                    </Grid>
                }
                {categoryData.categoryType === t("digitalVaultCategoriesAdministration.main.grid.custom") &&
                    <>
                        <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className="digitalVaultCategoriesAdministrationNewCategory-paddingElements"
                        >
                            <ButtonAddHLPure
                                nameBtn={t("digitalVaultCategoriesAdministration.add.icon")}
                                iconAdd
                                onClickBtn={() => setShowAddIcon(true)}
                            />
                        </Grid>
                        <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className="digitalVaultCategoriesAdministrationNewCategory-paddingElements"
                        >
                            <InputHLPure
                                labelInput={t("digitalVaultCategoriesAdministration.add.category")}
                                required
                                typeInput={"text"}
                                inputActive
                                valueInput={categoryData.name}
                                handleChangeInput={(e) => setCategoryData({ ...categoryData, name: e.target.value })}
                                informationIcon
                                tooltipShow
                                positionTooltip={isMobile ? "top" : "right"}
                                titleTooltip={t("digitalVaultCategoriesAdministration.add.category")}
                                descriptionTooltip={t("digitalVaultCategoriesAdministration.add.enterNameCatCustom")}
                            />
                            {showError && <div>{t("digitalVaultCategoriesAdministration.add.error.enterCategoryName")}</div>}
                        </Grid>
                    </>
                }
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className='digitalVaultCategoriesAdministrationNewCategory-paddingElements'
                >
                    <DropDownBtnHLPure
                        labelDropDown={t("digitalVaultCategoriesAdministration.add.minimumVisualization")}
                        optionsDropDown={dropdownOptions}
                        onDropDownChange={(e) => setCategoryData({ ...categoryData, minimunVisualization: !e.target.value ? null : e.target.value })}
                        optionsValue={t("digitalVaultCategoriesAdministration.add.options.notAssigned")}
                        valueItem={"levelUser"}
                        nameOption={"name"}
                        informationIcon
                        tooltipShow
                        positionTooltip={isMobile ? "top" : "right"}
                        titleTooltip={t("digitalVaultCategoriesAdministration.add.visualizationLevel")}
                        descriptionTooltip={t("digitalVaultCategoriesAdministration.add.descMinimumVisualization")}
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="digitalVaultCategoriesAdministrationNewCategory-paddingElements"
                >
                    <TextAreaHLPure
                        labelTextArea={t("digitalVaultCategoriesAdministration.add.notes")}
                        handleChangeTextArea={(e) => setCategoryData({ ...categoryData, notes: e.target.value })}
                        valueTextData={categoryData.notes}
                    />
                </Grid>
                <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="digitalVaultCategoriesAdministrationNewCategory-container-btn"
                >
                    <div className="digitalVaultCategoriesAdministrationNewCategory-btn-cancel">
                        <ButtonHLPure
                            nameBtn={t("button.cancel")}
                            onClickBtn={() => setShowDetails(false)}
                        />
                    </div>

                    <ButtonHLPure
                        nameBtn={t("button.save")}
                        primary
                        onClickBtn={() => createCategoryCompany()}
                    />
                </Grid>
            </Grid>
            {showAddIcon && (
                <DialogTemplatePure
                    cancel={() => setShowAddIcon(false)}
                    title="govo.digital"
                    description={t("digitalVaultCategoriesAdministration.add.selectIconCategory")}
                    canelBtn={t("button.cancel")}
                    saveBtn={t("button.save")}
                    buttonStyles="digitalVaultCategoriesAdministrationNewCategory-align-buttons"
                    handleSubmitProfile={(e) => {
                        e.preventDefault()
                        setCategoryData({ ...categoryData, icon: saveImg })
                        setShowAddIcon(false)
                    }}
                >
                    <div
                        className="signatureProfilesDetailsView-container-gallery"
                        xs={12}
                    >

                        {categories_icons.map((item, index) => (
                            <div className="signatureProfilesDetailsView-container-icons">
                                <RadioButton
                                    className="signatureProfilesDetailsView-radioBtn-img"
                                    name="icon"
                                    value={item.relativePath}
                                    checked={saveImg === item.relativePath}
                                    onChange={({ value }) => setSaveImg(value)}
                                />
                                <img
                                    src={item.url}
                                    className="icon-style"
                                    key={index}
                                />
                            </div>
                        ))}
                    </div>
                </DialogTemplatePure>
            )}
        </>

    );
}

export default DigitalVaultCategoriesAdministrationAddCategory